import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { readPortal } from "@/lib/egyptJourney";
import JourneyGlyph from "@/components/JourneyGlyph";
import "@/components/EgyptJourney.css";

export default function PortalArrival() {
  const location = useLocation();
  const [destination, setDestination] = useState(null);
  useEffect(() => {
    const portal = readPortal(location.pathname);
    setDestination(portal);
    if (!portal) return undefined;
    const timer = window.setTimeout(() => setDestination(null), 1100);
    return () => window.clearTimeout(timer);
  }, [location.pathname]);
  return destination ? <div className="journey-portal-arrival" style={{ "--portal-accent": destination.accent }} aria-hidden="true"><span><JourneyGlyph glyph={destination.glyph} /></span>{destination.label}</div> : null;
}
